<app-layout-page>
  <app-layout-header [showBackButton]="true">
  </app-layout-header>

  <app-layout-content class="content">
    <h2 trans="phone_mfa.title">(title)</h2>

    <p trans="phone_mfa.instructions.p1"></p>
    @if (phoneNumber) {
      <p class="number-display">{{ phoneNumber }}</p>
    }

    <nom-otp-input
      [control]="pinInput"
      [errors]="errors.otpInputErrors()"
    ></nom-otp-input>

    @if (showResentMessage) {
      <app-icon-message
        messageType="alert"
        transMessage="phone_mfa.error.resent_code"
      ></app-icon-message>
    }

    @if (sendSmsError) {
      <app-icon-message messageType="alert">
        <span trans="phone_mfa.error.could_not_send.start"></span>
        <a (click)="sendSms()" trans="phone_mfa.error.could_not_send.button">(link)</a>
        <span trans="phone_mfa.error.could_not_send.end"></span>
      </app-icon-message>
    }

    @if (smsResendLimitError) {
      <app-icon-message
        messageType="alert"
        transMessage="phone_mfa.error.resend_limit"
      ></app-icon-message>
    }

    @if (canResendSms) {
      <div class="resend-area">
        @if (!isSendingSms) {
          <a class="resend-link" (click)="sendSms()" trans="phone_mfa.button.resend">(link)</a>
        }
        @if (isSendingSms) {
          <span class="resend-msg" trans="phone_mfa.resend_confirmation"></span>
        }
      </div>
    }
  </app-layout-content>

  <app-layout-buttons>
    @if (couldNotVerifyError || timeoutError || conflictError) {
      <app-icon-message messageType="alert">
        @if (couldNotVerifyError) {
          <span trans="phone_mfa.error.could_not_verify"></span>
        }
        @if (timeoutError) {
          <span trans="phone_mfa.error.timeout"></span>
        }
        @if (conflictError) {
          <span trans="phone_mfa.error.conflict"></span>
        }
      </app-icon-message>
    }

    <button
      class="btn btn-primary pull-center"
      (click)="verify()"
      [disabled]="form.invalid || busy"
      [appFocus]="form.valid"
      [trans]="busy ? 'phone_mfa.button.verifying' : 'phone_mfa.button.verify'"
    ></button>
  </app-layout-buttons>
</app-layout-page>
